export const buttonLinkTypeValues = {
  openInSameWindow: '_self',
  openInNewWindow: '_blank',
}

export const buttonLinkTypeNames = {
  openInSameWindow: 'Open in same window',
  openInNewWindow: 'Open in new window',
}
